import { render } from "./ScontractsList.vue?vue&type=template&id=2e8f6cc2"
import script from "./ScontractsList.vue?vue&type=script&lang=js"
export * from "./ScontractsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__